<!-- @format -->

<template>
	<el-slider v-model="value" />
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';

	interface Props {
		modelValue: number | null;
		pcProps: WidgetConfigType;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue === 0 ? 0 : props.modelValue ? +props.modelValue : undefined;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
